import styled from "styled-components";
import { StyledButtonIcon } from "../UI/Button/Button-styled";

export const OnBoardingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 14px 8px 14px;
  position: relative;
  p {
    margin: 0;
  }
`;

export const StyledTitle = styled.p`
  font-size: 19px;
  color: var(--fontColor);
  line-height: normal;
  /* font-weight: 500; */
`;

export const StyledDescription = styled.p`
  font-size: 14px;
  color: var(--fontColor);
  line-height: normal;
`;

export const OnBoardingFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 8px 8px 8px;
`;

export const CloseIconWrapper = styled(StyledButtonIcon)`
  position: absolute;
  right: 8px;
  top: 10px;
  cursor: pointer;
`;
